<template>
  <b-container>
    <page-headline>Admin Dashboard</page-headline>
    <b-row>
      <b-col cols="12" sm="6" lg="4" v-if="usersDashboardEnable" class="btn-col">
        <b-button variant="primary" block :to="{ name: 'users' }">Users </b-button>
      </b-col>
      <b-col cols="12" sm="6" lg="4" v-if="demandOverviewEnable" class="btn-col">
        <b-button variant="primary" block :to="{ name: 'admin-demand-overview' }">
          Demands
        </b-button>
      </b-col>
      <b-col cols="12" sm="6" lg="4" class="btn-col">
        <b-button variant="primary" block :to="{ name: 'admin-sellingoffers' }">
          Selling Offers (B2B Sales)
        </b-button>
      </b-col>
      <b-col cols="12" sm="6" lg="4" class="btn-col">
        <b-button variant="primary" block :to="{ name: 'admin-demands' }">
          Purchase Offers
        </b-button>
      </b-col>
      <b-col cols="12" sm="6" lg="4" class="btn-col">
        <b-button variant="primary" block :to="{ name: 'admin-accepted-purchaseoffers' }">
          Accepted Purchase Offers
        </b-button>
      </b-col>
      <b-col cols="12" sm="6" lg="4" class="btn-col">
        <b-button variant="primary" block v-if="purchaseOrdersOverviewEnable" :to="{ name: 'admin-orders' }">
          Purchase Orders
        </b-button>
      </b-col>
      <b-col cols="12" sm="6" lg="4" class="btn-col">
        <b-button variant="success" block v-b-modal="'modal-scoped'">
          <b-icon-plus scale="2"/> Create Strategic Demand
        </b-button>
      </b-col>
      <admin-strategic-demand-form></admin-strategic-demand-form>
    </b-row>
  </b-container>
</template>

<script>
import AdminStrategicDemandForm from 'Components/admin/demand/AdminStrategicDemandForm';
import PageHeadline from 'Components/common/PageHeadline';
import featuresFlags from '@/mixins/featuresFlags';

export default {
  name: 'Admin',
  mixins: [featuresFlags],
  components: {
    PageHeadline,
    AdminStrategicDemandForm,
  },
  data() {
    return {
      showStrategicDemandForm: false,
    };
  },
  methods: {
    openStrategicDemandForm() {
      this.showStrategicDemandForm = true;
    },
    closeStrategicDemandForm() {
      this.showStrategicDemandForm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-col {
  margin-bottom: 1em;
}
</style>
